<template>
  <div class="header-content">
    <div class="header">
      <h1 class="header_h1 font-super">杭州市萧山区历史建筑展示平台</h1>
      <ul class="header-nav-list">
        <router-link
          :target="item.target"
          :to="item.path"
          class="header-nav-list-item font-h3"
          :class="navIsActive == item.path ? 'header-nav-isActive' : ''"
          v-for="(item, index) in navList"
          :key="index"
          >{{ item.navName }}</router-link
        >
        <el-dropdown placement="bottom-end">
          <li
            class="header-nav-list-item font-h3"
            :class="navIsActive == '/user' ? 'header-nav-isActive' : ''"
          >
            <img src="../../assets/images/header.svg" alt />
            <el-dropdown-menu slot="dropdown" class="header-menu">
              <el-dropdown-item @click.native="handleToUserSettings"
                >账号设置</el-dropdown-item
              >
              <el-dropdown-item @click.native="handleLogout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </li>
        </el-dropdown>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { adminNavList, navList } from './header-nav.js';
import { logout } from '../../api/index';

//eslint-disable-next-line
const routerReg = /([^\/]*\/[^\/]*)\/.*/; //用于切割路由字符串
export default {
  name: 'HeaderNav',
  data() {
    return {
      // navList: ''
    };
  },
  computed: {
    navIsActive() {
      return this.$route.path.replace(routerReg, '$1');
    },
    navList() {
      const test = this.authorizationLimit.some(e => {
        return e == 1;
      });
      if (test) {
        return adminNavList;
      } else {
        return navList;
      }
    },
    ...mapGetters('login', ['userInfo', 'authToken', 'authorizationLimit'])
  },
  methods: {
    ...mapMutations('login', [
      'setUserInfo',
      'setAuthToken',
      'setAuthorizationLimit'
    ]),
    /**
     * 进入账号设置界面回调
     */
    handleToUserSettings() {
      this.$router.push({ path: '/user' });
    },
    /**
     * 退出登录回调
     */
    handleLogout() {
      const userUid = String(this.userInfo.uid);

      logout(userUid).then(res => {
        if (res.data.code == 200) {
          this.setUserInfo('');
          this.setAuthToken('');
          localStorage.setItem('token', '');
          this.setAuthorizationLimit([]);
          this.$router.push({
            name: 'Login'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-content {
  box-sizing: content-box;
  height: 72px;
}
.header {
  width: 1024px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 22px;
  position: fixed;
  z-index: 250;
  background-color: #fff;
  box-sizing: border-box;
  &_h1 {
    flex: 1;
    border-bottom: 2px solid $color-info-light;
  }
  &-nav-list {
    display: flex;
    &-item {
      padding: 0 12px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 2px solid $color-info-light;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      & img {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
      &:hover {
        border-bottom: 2px solid $color-primary-light;
      }
    }
  }
  &-nav-isActive {
    border-bottom: 2px solid $color-primary !important;
    color: $color-primary;
    font-weight: 500;
  }
}
.header-menu {
  width: 88px;
  height: 72px;
  padding: 0;
  top: 60px !important;
  .el-dropdown-menu__item {
    padding: 0;
    text-align: center;
    font-size: 13px;
    &:hover {
      background-color: #fff;
      color: $color-primary;
    }
  }
  /deep/.popper__arrow {
    display: none !important;
  }
}
</style>
